<h2 mat-dialog-title>{{ 'PENDING_APPROVALS_CARD.DECLINE_ORDER_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'PENDING_APPROVALS_CARD.DECLINE_ORDER_DIALOG.CONTENT' | translate }}</p>
  <glxy-form-field>
    <textarea
      #rejectionReason
      matInput
      placeholder="{{ 'PENDING_APPROVALS_CARD.DECLINE_ORDER_DIALOG.PROVIDE_A_REJECTION_REASON' | translate }}"
    ></textarea>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'PENDING_APPROVALS_CARD.CANCEL' | translate }}</button>
  <button mat-flat-button color="warn" [disabled]="!rejectionReason.value" (click)="handleClick(rejectionReason.value)">
    {{ 'PENDING_APPROVALS_CARD.DECLINE' | translate }}
  </button>
</mat-dialog-actions>
